export default __webpack_public_path__ + "static/media/problem-solve.192e9e83.png";